<template>
  <div class="homepage">
  
    <div style="text-align:center; font-size:50px; color:#fff;margin-bottom: 50px;" v-text="category.name"></div>

    <hero :promoted="promoted"></hero>

    <section id="categories_list" class="centered" v-if="categories.length > 1">
      <div class="category_strip" v-for="cat in categories" :key="cat.id">
          <div class="strip_title"><span>{{cat.name}}</span></div>
          <carousel :autoplay="false" :responsive="{0:{items:3,nav:false},600:{items:4,nav:true}}" :margin="10" :rtl="true" :nav="true" :dots="false" :navText="['<div class=nav_right></div>','<div class=nav_left></div>']" >
            
           <itemTpl v-for="item in cat.items" :item="item" :key="item.id" /> 
            
          </carousel>
      </div>
    </section>

    <section id="categories_list" class="centered" v-if="categories.length == 1">
          <div class="row">
            <!-- <div class="col-md-3" v-for="item in categories[0].items" :key="item.id" > -->
            <div class="col-md-3" v-for="item in activeItems" :key="item.id" >
              <itemTpl class="" :item="item" :key="item.id"  />
            </div>
          </div>
    </section>

  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
//import { constants } from 'crypto';
import itemTpl from './item_tpl.vue'
import hero from './hero_items.vue'


export default {
  components: { carousel, itemTpl, hero },

  data() {
    return {
      promoted: [],
      categories: [], 
      category: [], 
      id: this.$route.params.id,
      type: this.$route.params.type,
      wordType: ["movie", "series"],    
    };

  },
  computed: {
  activeItems: function () {
   let  typein = this.type;
    let movietypein ;
    if (typein){
       movietypein = this.wordType[typein - 1];
    }
    return this.categories[0].items.filter(function (categoryType) {
      if(movietypein)
        return categoryType.type == movietypein;
      else
        return categoryType.type == "movie" || "series";
    })
        
  }
},
  methods: {
    
  },
  updated: function () {
      window.dispatchEvent(new Event('resize'));

  },
  created() {

    this.$emit('show_loader');
    var self = this;

    // categories
    this.api_call({ url: 'category', data: { id: this.id }, onComplete: function(data){
      // promoted

      for (var i in data.data.data.promoted)
      {
        data.data.data.promoted[i].is_active = (i == 0);
      }
      self.promoted = data.data.data.promoted;

      // Categories
      self.categories = data.data.data.categories;
      self.category = data.data.data.category;

      self.$emit('loaded');
    }});
    
  }
}
</script>